import { render, staticRenderFns } from "./CommonRecord.vue?vue&type=template&id=3410bce7&scoped=true"
import script from "./CommonRecord.vue?vue&type=script&lang=ts"
export * from "./CommonRecord.vue?vue&type=script&lang=ts"
import style0 from "./CommonRecord.vue?vue&type=style&index=0&id=3410bce7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3410bce7",
  null
  
)

export default component.exports